import { render } from "./CardSimple.vue?vue&type=template&id=393844fd&scoped=true"
import script from "./CardSimple.vue?vue&type=script&lang=js"
export * from "./CardSimple.vue?vue&type=script&lang=js"

import "./CardSimple.vue?vue&type=style&index=0&id=393844fd&scoped=scoped&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-393844fd"]])

export default __exports__